import { render, staticRenderFns } from "./academicInfo.vue?vue&type=template&id=13d574b7&scoped=true"
import script from "./academicInfo.vue?vue&type=script&lang=js"
export * from "./academicInfo.vue?vue&type=script&lang=js"
import style0 from "./academicInfo.vue?vue&type=style&index=0&id=13d574b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d574b7",
  null
  
)

export default component.exports